var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.079,
    height: 25.047,
    viewBox: "0 0 25.079 25.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-attention-7184147",
    transform: "translate(0.651 0.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291899",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291899",
    d: "M9.89,565.657a2.94,2.94,0,0,0-1.91-.235l-.391-1.252a.928.928,0,0,0-1.628-.286l-.869,1.1a7.6,7.6,0,0,1-3.643,2.532l-1.26.391a1.2,1.2,0,0,0-.783,1.507l.763,2.3a1.175,1.175,0,0,0,.595.7,1.209,1.209,0,0,0,.556.133,1.108,1.108,0,0,0,.391-.063l.458-.149,2.047,4.105a.657.657,0,0,0,.583.356.744.744,0,0,0,.207-.031l1.448-.47a.656.656,0,0,0,.43-.446.645.645,0,0,0-.125-.618.417.417,0,0,0-.059-.059l-.845-.657-1.092-2.806a7.7,7.7,0,0,1,2.614.266l1.346.391a.928.928,0,0,0,1.135-1.174l-.391-1.252a2.541,2.541,0,0,0,1.565-3.006,2.222,2.222,0,0,0-1.143-1.28Zm-8.453,6.089a.422.422,0,0,1-.509-.266l-.744-2.3a.391.391,0,0,1,.262-.521l1.26-.391.153-.082,1.131,3.06-.3.086Zm3.726,3.17a.41.41,0,0,0,.125.168l.7.54-1.123.364L2.884,572.1h.043a7.841,7.841,0,0,1,1.025-.254Zm3.913-3.338a.145.145,0,0,1-.145.039l-1.35-.376a8.412,8.412,0,0,0-3.831-.168L2.575,567.9a8.4,8.4,0,0,0,3.131-2.438l.865-1.1a.14.14,0,0,1,.113-.055h.027a.132.132,0,0,1,.113.1l.521,1.6,1.244,3.824.521,1.593a.142.142,0,0,1-.031.157Zm.129-2.387-.982-3.017a2.167,2.167,0,0,1,1.315.176,1.415,1.415,0,0,1,.736.826,1.768,1.768,0,0,1-1.064,2.015Z",
    transform: "translate(0 -551.765)",
    fill: "#ff8a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291900",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291900",
    d: "M568.29-.012A6.629,6.629,0,0,0,562.733,10.3l-.7,2.462a.389.389,0,0,0,.38.5.368.368,0,0,0,.113,0l2.591-.783A6.653,6.653,0,1,0,568.29-.012Zm0,12.488a5.869,5.869,0,0,1-2.931-.783.392.392,0,0,0-.2-.051.368.368,0,0,0-.114,0l-2.066.622.56-1.957a.39.39,0,0,0-.055-.333,5.87,5.87,0,1,1,4.8,2.5Z",
    transform: "translate(-550.534 0)",
    fill: "#ff8a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291901",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291901",
    d: "M824.863,428.26a1.174,1.174,0,1,0,1.174,1.174A1.174,1.174,0,0,0,824.863,428.26Zm0,1.565a.392.392,0,1,1,.391-.391.391.391,0,0,1-.391.391Z",
    transform: "translate(-807.134 -419.334)",
    fill: "#ff8a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291902",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291902",
    d: "M826.184,95.25a1.174,1.174,0,0,0-1.174,1.174v4.305a1.174,1.174,0,1,0,2.348,0V96.424A1.174,1.174,0,0,0,826.184,95.25Zm.391,5.479a.391.391,0,0,1-.783,0V96.424a.391.391,0,0,1,.783,0Z",
    transform: "translate(-808.428 -93.274)",
    fill: "#ff8a00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionYellow);
export default __webpack_public_path__ + "static/media/attentionYellow.151312ae82a5eccdf824e4500aed72f6.svg";
export { ForwardRef as ReactComponent };